export class Stage {
  constructor(
    public id: number,
    public beginDate: Date,
    public endDate: Date,
    public stageNatureTypeId: number,
    public stageState: string,
    public label?: string,
    public duration?: number,
    public organization?: string,
    public comment?: string,
    public communityActionId?: number,
    public sessionId?: number,
  ) {}

  public static fromJson(json: any): Stage {
    return new Stage(
      json.id,
      json.beginDate ? new Date(json.beginDate) : undefined,
      json.endDate ? new Date(json.endDate) : undefined,
      json.stageNatureTypeId,
      json.stageState,
      json.label,
      json.duration,
      json.organization,
      json.comment,
      json.communityActionId,
      json.sessionId,
    );
  }

  public static undefinedStage(): Stage {
    return {} as Stage;
  }
}
